import { render, staticRenderFns } from "./TituloGerenciarBoletos.vue?vue&type=template&id=7970b15b&"
import script from "./TituloGerenciarBoletos.vue?vue&type=script&lang=js&"
export * from "./TituloGerenciarBoletos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports